import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ConfirmationService } from 'primeng/api';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ToastModule } from 'primeng/toast';

import { ProgressIndicatorComponent } from './shared/components/progress-indicator/progress-indicator.component';
import { UpperMenuComponent } from './shared/components/upper-menu-component/upper-menu';
import { RouterService } from './shared/services/router.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  providers: [ConfirmationService],
  imports: [UpperMenuComponent, ProgressIndicatorComponent, ToastModule, ConfirmDialogModule, RouterOutlet],
})
export class AppComponent {
  title = 'fmc-schedulewise-client';

  constructor() {
    const routerService = inject(RouterService);

    routerService.monitor();
  }
}
